import { render, staticRenderFns } from "./OtherFacilitiesApplicationModal.vue?vue&type=template&id=61fd5734&scoped=true&lang=pug"
import script from "./OtherFacilitiesApplicationModal.vue?vue&type=script&lang=ts"
export * from "./OtherFacilitiesApplicationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fd5734",
  null
  
)

export default component.exports